import React from 'react';
import { Card, Text, useResponsiveParams } from 'quanta-ui';
import { ClientService, Layout } from 'quanta-flows/modules/layout';
import { useParams } from 'react-router-dom';
import ViewPolicySA from './fire/standalone-fire/view-policy-fire';
import { LOB_PRODUCT_LIST } from './queries';
import { useQuery } from '@apollo/client';
import { Loading } from 'quanta-flows/modules/layout';
import { Error } from 'quanta-flows/modules/layout';

export default function ViewPolicy({ lobName }) {
  const { lob_name, lob_code } = useParams();
  const textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl',
  });

  const lob_Name = lobName ? lobName : lob_name;
  const { loading, error, data } = useQuery(LOB_PRODUCT_LIST, {
    fetchPolicy: 'cache-first',
  });
  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Error error={error} />;
  }
  const { lobProductList } = data;

  if (
    lobProductList?.find(
      (lob) =>
        lob?.lob_code?.toLowerCase() === lob_code?.toLowerCase() &&
        lob?.lob_name?.toLowerCase() === lob_name?.toLowerCase(),
    )
  ) {
    if (
        lob_name?.toString()?.trim()?.toLowerCase()?.search('fire') !==
        -1 
    ) {
      return <ViewPolicySA lobProductList={lobProductList} />;
    } else {
      return (
        <Layout
          nav={['Quote', 'View Quote']}
          service_type={ClientService}
        >
          <Card className="h-screen" severity={`error`}>
            <Text
              severity={'error'}
              className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
            >
              Given Lob is not Available or Invalid
            </Text>
          </Card>
        </Layout>
      );
    }
  } else {
    return (
      <Layout
        nav={['Quote', 'View Quote']}
        service_type={ClientService}
      >
        <Card className="h-screen" severity={`error`}>
          <Text
            severity={'error'}
            className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
          >
            Given Lob is not Available or Invalid
          </Text>
        </Card>
      </Layout>
    );
  }
}
